import {Component, Injector} from '@angular/core';

import {
  DeleteDeliveryPointViewModel
} from "@app/presentation/pages/delete-delivery-point/delete-delivery-point.view-model";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {take} from "rxjs/operators";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {SIDE_SHEET_DATA} from "@app/presentation/services/side-sheet/side-sheet.service";
import {ExitService} from "@app/presentation/services/exit.service";
import {ToastService} from "@app/presentation/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-delete-delivery-point',
  templateUrl: './delete-delivery-point.component.html',
  styleUrls: ['./delete-delivery-point.component.scss']
})
export class DeleteDeliveryPointComponent {

  private readonly deliveryPointCode?:number;

  isDeleteDeliveryPointLoading$ = this.deleteDeliveryPointViewModel.isDeleteDeliveryPointLoading$

  constructor(
      private deleteDeliveryPointViewModel:DeleteDeliveryPointViewModel,
      private injector:Injector,
      popupDispatcher: PopupDispatcher,
      private toastService: ToastService,
      private translateService: TranslateService,
  ) {

    try {
      const bottomSheetData = injector.get(MAT_BOTTOM_SHEET_DATA)
      this.deliveryPointCode = bottomSheetData?.deliveryPointCode;
    } catch { }

    try {
      const sideSheetData = injector.get(SIDE_SHEET_DATA)
      this.deliveryPointCode = sideSheetData?.deliveryPointCode;

    } catch { }

    popupDispatcher.setNotifier(this.deleteDeliveryPointViewModel.notifier);
  }


  deleteDeliveryPoint() {
    if(this.deliveryPointCode) {
      this.deleteDeliveryPointViewModel.deleteDeliveryPoint(this.deliveryPointCode)
          .pipe(take(1))
          .subscribe({
            next: () => {
            this.toastService.show(this.translateService.instant('action_message.delivery_point.successfully_deleted'));
            this.close();
          }
      });
    }
  }

  close() {
    try {
      const bottomSheetRef = this.injector.get(MatBottomSheetRef);
      bottomSheetRef.dismiss();
      return;
    } catch {}
    ExitService.exit(this.injector)
  }

}
